import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ISalonsSearchResults } from '@app/salons-search-results/models/salons-search-results.model';
import { SalonsSearchService } from '@app/shared/services/salons-search/salons-search.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalonSearchResolverService implements Resolve<ISalonsSearchResults> {

  constructor(private salonsSearchService: SalonsSearchService) { }

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<ISalonsSearchResults> {
    const cityName = route.paramMap.get('cityName');
    const departmentName = route.paramMap.get('departmentName');
    if (departmentName) {
      return this.salonsSearchService.getSalonsByCityAndDepartment(cityName, departmentName);
    }
    return this.salonsSearchService.getSalonsByCity(cityName);
  }
}
